/* eslint-disable @typescript-eslint/naming-convention */

import { Entity } from "src/app/shared/types/entity.type";
import { Company } from "../companies/company.type";
import { MaintenanceProvider } from "../maintenance-provider/maintenance-provider.types";
import { User } from "../users/user.type";

export interface Partner extends Entity {
  id: string;
  name: string;
  specialType: PartnerSpecialTypes;
  type: string;
  status: "active" | "inactive";
  partnerIdentifier: string;
  logo?: string;
  isResellerNeeded?: boolean;
  maintenanceProviders?: MaintenanceProvider[];
  users: User[];
  companies: Company[];
}

export const FILE_RESTRICTIONS = {
  maxSize: 500000, // 500 KB
  maxWidth: 1500,
  maxHeight: 300,
};

export enum PartnerSpecialTypes {
  Relutech = "relutech",
}

export type PartnerSpecialType = `${PartnerSpecialTypes}`;
